import Cookie from 'js-cookie';
import { SiteUtilities } from '.';

let eventObj = {};
const init = function () {
  if ($('#page-category-tag').length) {
    eventObj.tag = $('#page-category-tag').val();
    eventObj.event = 'page_category_tag';
    pushEventToDataLayer();
  }

  $('body').on('click', function (e) {
    const $targetElement = $(e.target);
    if (($targetElement.hasClass('logo') || $targetElement.hasClass('product-logo-icon')) && $targetElement.parents('.nav-primary-wrapper').length) {
      eventObj.logo_name = 'Primary Navigation';
      eventObj.event = 'logo_click';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    }

    if (($targetElement.hasClass('logo') || $targetElement.hasClass('nav-super-logo')) && $targetElement.parents('.nav-super').length) {
      eventObj.logo_name = 'Super Navigation';
      eventObj.event = 'logo_click';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    }

    if (($targetElement.hasClass('nav-super-label') && $targetElement.parents('.nav-super-menu').length) || (($targetElement.hasClass('nav-label')) && $targetElement.parents('.nav-main-menu').length) || (($targetElement.hasClass('nav-sub-label')) && $targetElement.parents('.nav-sub-menu').length && $targetElement.parents('.nav-secondary-wrapper').length)) {
      eventObj.navigation_labels = `${e.target.innerText} | null`;
      eventObj.event = 'navigation_menu_click';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    }

    if ($targetElement.parents('footer').length) {
      eventObj.footer_clicks = $targetElement[0] ? $targetElement[0].innerText : '';
      eventObj.previous_page = document.referrer;
      eventObj.event = 'footer_click';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    }

    if (($targetElement.hasClass('shopify-sso'))) {
      postGAEvent('Singup Option Chooser', 'Shopify Chosen', 'Option Successfully Chosen', 'shopify-sso', 'Shopify Chosen');
    }

    if (($targetElement.hasClass('button'))) {
      if ($targetElement.parents('nav').length) {
        eventObj.event = 'navigation_menu_click';
        eventObj.navigation_labels = e.target.value || e.target.innerText;
      } else if ($targetElement.parents().hasClass('pricing-table-body')) {
        try {
          eventObj.button_name = 'Pricing page signup click';
          eventObj.event = 'pricing_page_sign_up_click';
          const pricingModule = $targetElement.parents('.pricing-tab-wrapper').find('.nav-tablist > li > a[aria-expanded="true"]').text();
          eventObj.pricing_module = pricingModule;
          const pricingSubModule = $targetElement.closest('.pricing-table-column').find('.pricing-table-plan-name').text();
          eventObj.pricing_sub_module = pricingSubModule;
          eventObj.button_text = e.target.value || e.target.innerText;
        } catch (e) {}
      } else {
        eventObj.button_name = 'CTA Button Click';
        eventObj.event = 'cta_click_event';
        eventObj.button_text = e.target.value || e.target.innerText;
        eventObj.scroll = getScrolledPercentage();
        const email = $targetElement.parents('form').find('input.email-form').val();
        if (email && email.length && window.OptanonActiveGroups && window.OptanonActiveGroups.includes('C0004')) {
          eventObj.ehash = SiteUtilities.getShaHash(email);
        }
      }
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    }

    if ($targetElement.hasClass('forgot-domain-link')) {
      eventObj.event = 'forgot_helpdesk';
      pushEventToDataLayer();
    }

    if ($targetElement.hasClass('accordion-heading') || $targetElement.hasClass('accordion-float-wrapper')) {
      const faqInteraction = $targetElement.parents('.accordion-wrapper').hasClass('accordion-wrapper-opened') ? 'expand_click' : 'collapse_click';
      eventObj.event = 'page_interaction_faq';
      eventObj.faq_question = $targetElement.hasClass('accordion-heading') ? $targetElement.text() : $targetElement.find('.accordion-heading').text();
      eventObj.interaction_action = faqInteraction; // eg: expand_click, collapse_click
      pushEventToDataLayer();
    }

    if ($targetElement.attr('id') === 'autofill-button') {
      postGAEvent('Signup Option Chooser', 'LinkedIn AutoFill', 'Option Successfully Chosen', '', 'LinkedIn AutoFill');
    }
  });

  $('.banner-notification').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      eventObj.event = 'hello_bar_click';
      eventObj.hello_bar_name = $(e.target).hasClass('banner-notification') ? $(e.target).text().replaceAll('\n', '').trim() : $(e.target).parents('.banner-notification').text().replaceAll('\n', '').trim();
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {
    }
  });

  $('.link:not(.feature-bucket .l-col-widget .link), .feature-bucket .l-col-widget a').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      const featureHeader = $(this).closest('.l-col-widget').find(':header');
      eventObj.button_name = 'Non CTA Link Button Click';
      eventObj.event = 'internal_click';
      eventObj.button_text = featureHeader.length ? featureHeader[0].innerText : e.target.innerText;
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.customer-logo').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      eventObj.event = 'customer_logo_click';
      eventObj.customer_logo = $targetElement.children('.lazy-image-wrapper').children('img')[0].alt || $targetElement.children('.lazy-image-wrapper').children('img')[0].currentSrc;
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.badge-logo').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      eventObj.event = 'badge_logo_click';
      eventObj.badge_logo = $targetElement[0].outerText || $targetElement.children('.lazy-image-wrapper').children('img')[0].currentSrc;
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.pricing-page .pricing-tab-wrapper .nav-tablist li a').on('click', function (e) {
    setTimeout(function () {
      try {
        const $targetElement = $(e.target);
        eventObj.event = 'pricing_module_click';
        const pricingModule = $targetElement.parents('.pricing-tab-wrapper').find('.nav-tablist > li > a[aria-expanded="true"]').text();
        eventObj.pricing_module = pricingModule;
        pushEventToDataLayer();
      } catch (e) {
      }
    }, 0);
  });

  $('.pricing-table-support-details a.pricing-detail-link').on('click', function (e) {
    try {
      eventObj.button_text = e.target.innerText;
      eventObj.event = 'internal_click';
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.pricing-page .explore-addons-wrapper a.show-more').on('click', function (e) {
    try {
      eventObj.button_text = e.target.innerText;
      eventObj.event = 'internal_click';
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.horizontal-tab-wrapper.ui-preview .nav-tablist li').on('click', function (e) {
    try {
      eventObj.button_text = e.target.innerText;
      eventObj.event = 'internal_click';
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.vertical-tab-wrapper.vertical-tab-wrapper-v3 .nav-tablist li').on('click', function (e) {
    try {
      eventObj.button_text = e.target.innerText;
      eventObj.event = 'internal_click';
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.vertical-tab-wrapper.vertical-tab-pricing-wrapper.tablist-container .nav-tablist li').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      eventObj.button_name = 'Freshdesk add on click';
      eventObj.event = 'add_on_click';
      const addOnTab = $targetElement.closest('li').children('a').children('.add-on-tab-heading')[0].innerText;
      eventObj.add_on = addOnTab;
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.add-ons-footer .button').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      eventObj.button_name = 'Add on signup click';
      eventObj.event = 'add_on_sign_up_click';
      const addOnHeading = $targetElement.closest('.tab-pane').children('.add-on-content-heading').children('h3')[0].outerText;
      eventObj.add_on = addOnHeading;
      eventObj.button_text = e.target.value || e.target.innerText;
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('a').on('click', function () {
    const href = $(this).attr('href');
    if (href && (href.includes('tel:') || href.includes('mailto:'))) {
      eventObj.event = 'outbound_links';
      if ($(this).attr('href').includes('tel:')) {
        eventObj.call_click = href.replace('tel:', '');
        eventObj.email_click = '';
      } else if ($(this).attr('href').includes('mailto:')) {
        eventObj.call_click = '';
        eventObj.email_click = href.replace('mailto:', '');
      }
      eventObj.footer_clicks = $(this).parents('.footer-main').length > 0;
      pushEventToDataLayer();
    }
  });

  // nav hover is handled differently in navigation.js so its click event is not captured in above body click
  $('.language-selector-card .language-wrapper').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      const $language = $targetElement.closest('.language-wrapper span.label');
      eventObj.selected_language = $language[0] ? $language[0].innerText : '';
      eventObj.event = 'language_selection';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  $('.card-item:not(.fd-review-card-list)').on('click', function (e) {
    try {
      const $targetElement = $(e.target).parents('.card-item');
      eventObj.event = 'content_card_click';
      eventObj.button_text = $targetElement.find('.resource-box-right > p > strong').text() || $targetElement.find('.resource-box-right > p').text();
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {}
  });

  $('.activity-card').on('click', function (e) {
    try {
      const $targetElement = $(e.currentTarget);
      eventObj.event = 'content_card_click';
      eventObj.button_text = $targetElement.find('.activity-title').text() || ($targetElement.find('p').length ? $targetElement.find('p')[0].innerText : '');
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {}
  });

  $('.story-card .card-content').on('click', function (e) {
    try {
      const $targetElement = $(e.currentTarget);
      eventObj.event = 'content_card_click';
      eventObj.button_text = $targetElement.find('.press-release-title :header').text() || ($targetElement.find('p').length ? $targetElement.find('p')[0].innerText : '');
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {}
  });

  $('.mosaic-item').on('click', function (e) {
    try {
      const $targetElement = $(e.currentTarget);
      eventObj.event = 'content_card_click';
      eventObj.button_text = $targetElement.find('.mosaic-content').text();
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {}
  });

  $('body .nav-super-menu .nav-sub-menu .nav-sub-item').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      const navText = $targetElement.parents('.nav-super-item').children('.nav-super-label')[0].innerText;
      const navLabel = (navText !== '') ? navText : null;
      const subNavLabel = (e.target.innerText !== '') ? e.target.innerText : null;
      eventObj.navigation_labels = `${navLabel} | ${subNavLabel}`;
      eventObj.event = 'navigation_menu_click';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  const mouseOverSuper = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement[0].innerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.nav-super .nav-super-menu .nav-super-item').on('mouseenter', function (e) {
    mouseOverSuper(e);
  });

  $('body .nav-main-menu .nav-sub-menu .nav-sub-item').on('click', function (e) {
    try {
      const $targetElement = $(e.target);
      const navText = $targetElement.parents('.nav-main-item').children('.nav-label')[0].innerText;
      const navLabel = (navText !== '') ? navText : null;
      const subNavLabel = (e.target.innerText !== '') ? e.target.innerText : null;
      eventObj.navigation_labels = `${navLabel} | ${subNavLabel}`;
      eventObj.event = 'navigation_menu_click';
      setDestinationUrl($targetElement);
      pushEventToDataLayer();
    } catch (e) {

    }
  });

  const mouseOver = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement[0].innerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.nav-primary .nav-main-menu .nav-main-item').on('mouseenter', function (e) {
    mouseOver(e);
  });

  const mouseOverSec = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement[0].outerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.nav-secondary .nav-secondary-item .nav-sub-item').on('mouseenter', function (e) {
    mouseOverSec(e);
  });

  const mouseOverPlatform = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement[0].innerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.platform-nav-main-item .nav-main-item-title').on('mouseenter', function (e) {
    mouseOverPlatform(e);
  });

  const mouseOverPlatformSubItem = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement[0].innerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.platform-card .partner-nav-sub-item').on('mouseenter', function (e) {
    mouseOverPlatformSubItem(e);
  });

  const mouseOverPlatformProductHeading = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement[0].innerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.platform-card .nav-main-item-list .product-heading').on('mouseenter', function (e) {
    mouseOverPlatformProductHeading(e);
  });

  const mouseOverPlatformSubProduct = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement.closest('.card-width')[0].outerText.split('\n')[0];
      eventObj.nav_sub_label = $targetElement[0].innerText.split('\n')[0] || $targetElement[0].innerText;
      eventObj.event = 'navigation_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.platform-card .nav-main-item-list .nav-main-item-link').on('mouseenter', function (e) {
    mouseOverPlatformSubProduct(e);
  });

  $('body .nav-secondary-wrapper .nav-sub-menu .nav-sub-label').on('click', function (e) {
    const $targetElement = $(e.target);
    eventObj.navigation_labels = `${e.target.innerText} | null`;
    eventObj.event = 'navigation_menu_click';
    setDestinationUrl($targetElement);
    pushEventToDataLayer();
  });

  const mouseOverLabel = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement.parents('.nav-main-item').children('.nav-label')[0].innerText || null;
      eventObj.nav_sub_label = `${e.target.innerText}`;
      eventObj.event = 'navigation_sub_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.nav-primary .nav-sub-menu .nav-sub-item .nav-sub-label').on('mouseenter', function (e) {
    mouseOverLabel(e);
  });

  const mouseOverSuperLabel = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.nav_label = $targetElement.parents('.nav-super-item')[0].innerText.split('\n')[0];
      eventObj.nav_sub_label = `${e.target.innerText}`;
      eventObj.event = 'navigation_sub_menu_hover';
      pushEventToDataLayer();
    } catch (e) {

    }
  };

  $('.nav-super .nav-super-menu .nav-sub-menu .nav-sub-label').on('mouseenter', function (e) {
    mouseOverSuperLabel(e);
  });

  $('.accordion-link').on('click', function (e) {
    if ($(this).text()) {
      eventObj.button_name = 'Non CTA Link Button Click';
      eventObj.button_text = $(this).text().trim();
      eventObj.event = 'internal_click';
      pushEventToDataLayer(e);
    }
  });

  $('.pricing-product-list a').on('click', function (e) {
    const $targetElement = $(e.target);
    const navLabel = $(this).find('.pricing-product-name').text().replace(/\s+|\n/g, char => char === '\n' ? '' : ' ').trim();
    const subNavLabel = $(this).find('.product-desc').text();
    eventObj.event = 'sub_product_dropdown_click';
    eventObj.navigation_labels = `${navLabel} | ${subNavLabel}`;
    setDestinationUrl($targetElement);
    pushEventToDataLayer();
  });

  if ($('.pricing-table-features-list .tool-tip-button').length) {
    let mouseEnterTime;
    $('.pricing-table-features-list .tool-tip-button').on({
      mouseenter: function () {
        mouseEnterTime = new Date().getTime();
      },
      mouseleave: function () {
        const mouseLeaveTime = new Date().getTime();
        if (mouseLeaveTime - mouseEnterTime > 1000) {
          const pricingPlanFeature = $(this).closest('.feature-tool-tip');
          eventObj.event = 'pricing_page_tooltip_hover';
          eventObj.tooltip_name = pricingPlanFeature.find('[id^="pricing-feature--"]').text().trim();
          eventObj.tooltip_text = pricingPlanFeature.find('.tool-tip-content').text();
          pushEventToDataLayer();
        }
      }
    });
  }

  const formFalloutEvent = (e) => {
    try {
      const $targetElement = $(e.target);
      eventObj.button_text = $targetElement.parents('form').find('input.button')[0].value;
      eventObj.form_name = $targetElement.parents('form')[0].className;
      eventObj.field_step = e.target.name;
      eventObj.previous_step = document.referrer;
      eventObj.event = 'form_fallout';
      pushEventToDataLayer();
    } catch (error) {

    }
  };

  $('input').on('blur', function (e) {
    formFalloutEvent(e);
  });

  $('textarea').on('blur', function (e) {
    formFalloutEvent(e);
  });

  $('select').on('blur', function (e) {
    formFalloutEvent(e);
  });

  // gdpr events
  const gdprCheckbox = '.gdpr.form-field input[name="send_promotions"]';
  $(gdprCheckbox).on('click', function (e) {
    try {
      if ($(e.target).is(':checked')) {
        postGAEvent('ConsentCheckboxExperiment', 'Consent', 'True', '', 'EUFormsCheckbox');
      }
    } catch (e) {
    }
  });

  const formSubmitEvent = (e) => {
    try {
      if (!$(e.target).parents('form').find(gdprCheckbox).is(':checked')) {
        postGAEvent('ConsentCheckboxExperiment', 'Consent', 'False', '', 'EUFormsCheckbox');
      }
    } catch (error) {

    }
  };

  // submit events
  $('input[type="submit"].button').on('click', formSubmitEvent);
  $('button[type="submit"].button').on('click', formSubmitEvent);

  const formInitiateEvent = (e, isFormInitiated) => {
    try {
      if (!isFormInitiated) {
        isFormInitiated = true;
        const $targetElement = $(e.target);
        eventObj.button_text = $targetElement.parents('form').find('input.button')[0].value;
        eventObj.form_name = $targetElement.parents('form')[0].className;
        eventObj.field_step = e.target.name;
        eventObj.previous_step = document.referrer;
        eventObj.event = 'form_initiate';
        pushEventToDataLayer();
        SiteUtilities.captureFormInitiateTime();
      }
      return isFormInitiated;
    } catch (error) {

    }
  };

  const $forms = $('form');
  $forms.each(function () {
    let isFormInitiated = false;

    // keyup events
    $(this).find('input').on('keyup change', function (e) {
      isFormInitiated = formInitiateEvent(e, isFormInitiated);
    });

    $(this).find('textarea').on('keyup', function (e) {
      isFormInitiated = formInitiateEvent(e, isFormInitiated);
    });

    // click events
    $(this).find('select').on('click', function (e) {
      isFormInitiated = formInitiateEvent(e, isFormInitiated);
    });
  });

  // scroll
  function debounce (handler, delay) {
    clearTimeout(handler.timeoutId);
    handler.timeoutId = setTimeout(function () {
      handler();
    }, delay);
  }
  function handleScroll () {
    const scrollPercentage = getScrolledPercentage();
    eventObj.percent_scrolled = scrollPercentage;
    eventObj.event = 'scroll';
    pushEventToDataLayer();
  }

  $(window).scroll(function () {
    debounce(handleScroll, 1000);
  });

  function getScrolledPercentage () {
    return Math.round(100 * $(window).scrollTop() / ($(document).height() - $(window).height()));
  }

  function getAbsoluteUrl (href) {
    const link = document.createElement('a');
    link.href = href;
    return link.href;
  }

  function setDestinationUrl (targetElement) {
    try {
      const destinationUrl = targetElement.attr('href') || targetElement.closest('a').attr('href');
      eventObj.destination_url = destinationUrl ? getAbsoluteUrl(destinationUrl) : '';
    } catch (e) { }
  }

  // wistia
  try {
    window._wq = window._wq || [];
    window._wq.push({ id: '_all',
      onReady: function (video) {
        video.bind('play', function () {
          eventObj.event = 'video_interaction';
          eventObj.video_id = video._hashedId;
          eventObj.video_status = 'video_play';
          pushEventToDataLayer();
        });
      }
    });
    window._wq.push({ id: '_all',
      onReady: function (video) {
        video.bind('pause', function () {
          eventObj.event = 'video_interaction';
          eventObj.video_id = video._hashedId;
          eventObj.video_status = 'video_pause';
          pushEventToDataLayer();
        });
      }
    });
  } catch (e) {

  }
};

const ga4ThankYouEvent = (accountId, domainUrl, form) => {
  try {
    eventObj.event = 'thank_you_page';
    eventObj.button_text = (form.find('input.button')[0] && form.find('input.button')[0].value) || null;
    eventObj.account_id = accountId;
    eventObj.domain = domainUrl;
    eventObj.form_name = form[0].className;
    pushEventToDataLayer();
  } catch (e) {

  }
};

const addFormData = (formData) => {
  eventObj.event_params = {
    company: formData.company,
    email: formData.email,
    first_name: formData.firstName,
    last_name: formData.lastName
  };

  if (formData.phone) {
    eventObj.event_params.phonenumber = formData.phone;
  }
};

const postGAEvent = (name = '', action = '', label = '', className = '', category = '', formData = {}) => {
  try {
    eventObj.eventCategory = category;
    eventObj.event = name;
    eventObj.eventLabel = label;
    eventObj.eventAction = action;
    if (className.length) {
      eventObj.className = className;
    }
    if (name === 'fwFormSubmit' && window.OptanonActiveGroups && window.OptanonActiveGroups.includes('C0004')) {
      addFormData(formData);
    }
    pushEventToDataLayer();
  } catch (e) {

  }
};

const googleSSOEvent = (name = '', action = '', label = '', className = '', formData = {}) => {
  try {
    eventObj.eventCategory = 'Google SSO Experiment';
    eventObj.event = name;
    eventObj.eventLabel = label;
    eventObj.eventAction = action;
    if (className.length) {
      eventObj.className = className;
    }
    if (name === 'fwFormSubmit' && window.OptanonActiveGroups && window.OptanonActiveGroups.includes('C0004')) {
      addFormData(formData);
      eventObj.ehash = SiteUtilities.getShaHash(formData.email);
    }
    pushEventToDataLayer();
  } catch (e) {

  }
};

const signupRetryEvent = (event = '', category = '', action = '') => {
  try {
    eventObj.event = event;
    eventObj.eventCategory = category;
    eventObj.eventAction = action;
    pushEventToDataLayer();
  } catch (e) {

  }
};

const loginFormSubmit = (domain) => {
  try {
    eventObj.helpdesk_name = domain;
    eventObj.event = 'helpdesk_submit';
    pushEventToDataLayer();
  } catch (e) {

  }
};

const fwFormSubmit = (className, formData) => {
  try {
    eventObj.className = className;
    eventObj.event = 'fwFormSubmit';
    if (window.OptanonActiveGroups && window.OptanonActiveGroups.includes('C0004')) {
      addFormData(formData);
    }
    pushEventToDataLayer();
  } catch (e) {

  }
};

const freshchatEvents = (chatStatus) => {
  try {
    if (!chatStatus) return;
    eventObj.chat_status = chatStatus;
    eventObj.event = 'freshchat_widget';
    pushEventToDataLayer();
  } catch (e) {
  }
};

$('input[type=submit]').on('click', function () {
  try {
    const $form = $(this).closest('form');
    const isExpandedForm = $form.find('.email-form').data('generic-validate-on-blur');
    if (isExpandedForm) {
      if (!$form.valid()) {
        const genericFieldInvalid = $form.find(':invalid').not('.job-level-form, .website-form, .company-industry-form, fieldset').length > 0;
        const eventMsg = genericFieldInvalid ? 'Mandatory fields not filled' : 'New mandatory fields not filled';
        expandedFormEvent(eventMsg);
      }
    }
  } catch (e) {

  }
});

const expandedFormEvent = (label) => {
  try {
    eventObj.event = 'expanded_form_experiment';
    eventObj.eventCategory = 'Google SSO and Expanded Form Experiment';
    eventObj.eventAction = 'Normal Signup';
    eventObj.eventLabel = label;
    pushEventToDataLayer();
  } catch (e) {

  }
};

const pushEventToDataLayer = () => {
  eventObj.client_id = getGAId();
  eventObj.page_URL = window.location.href;
  setEventCookies(eventObj);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventObj);
  eventObj = {};
};

const setEventCookies = (eventObj) => {
  switch (eventObj.event) {
    case 'cta_click_event':
      SiteUtilities.setCookiesAsArrOfObj('fw_ue_cta', eventObj);
      break;
    case 'navigation_menu_click':
      SiteUtilities.setCookiesAsArrOfObj('fw_ue_navc', eventObj);
      break;
    case 'internal_click':
      SiteUtilities.setCookiesAsArrOfObj('fw_ue_ncta', eventObj);
      break;
    default:
      break;
  }
};

const getGAId = () => {
  return Cookie.get('_ga') || SiteUtilities.getTrackerClientId() || '';
};

// RH Events

const rhEventTypes = [
  'MEETING_BOOKED',
  'MEETING_RESCHEDULED',
  'CLOSE_ADD_GUEST',
  'ADDING_GUEST',
  'ADDED_GUEST',
  'RESIZE_IFRAME',
  'CLOSE_DIALOG',
  'INIT_REDIRECT',
  'PAGE_LOADED',
  'RESCHEDULE_CLICKED'
];

window.addEventListener('message', (event) => {
  if (event && event.data && event.data.type && rhEventTypes.includes(event.data.type)) {
    eventObj.event = `RH_${event.data.type}`;
    if (event.data.meeting) {
      eventObj.meeting = event.data.meeting;
    } else if (event.data.height) {
      eventObj.height = event.data.height;
    }
    eventObj.type = event.data.type;
    pushEventToDataLayer();
  }
});

export default { init, ga4ThankYouEvent, loginFormSubmit, googleSSOEvent, signupRetryEvent, fwFormSubmit, freshchatEvents, postGAEvent, expandedFormEvent, getGAId };
